import createIcon from '../../createIcon';

/**
 * @component @name Icecream
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNzkgMTEuOUwxMi4wNSAxOC4xMkwxNS4yMiAxMS45MUMxNS4xMSAxMS44MyAxNS4wMSAxMS43NSAxNC45MiAxMS42NkMxNC4wOCAxMi4xOSAxMy4wNyAxMi41IDEyIDEyLjVDMTAuOTMgMTIuNSA5LjkyIDEyLjE5IDkuMDggMTEuNjZDOC45OSAxMS43NSA4Ljg5IDExLjgzIDguNzkgMTEuOVpNNi44MyAxMi40OUM1LjI1IDEyLjQgNCAxMS4xIDQgOS41QzQgOC4wMSA1LjA5IDYuNzcgNi41MiA2LjU0QzYuNzUgMy43MiA5LjEyIDEuNSAxMiAxLjVDMTQuODggMS41IDE3LjI1IDMuNzIgMTcuNDggNi41NEMxOC45MSA2Ljc3IDIwIDguMDEgMjAgOS41QzIwIDExLjA5IDE4Ljc2IDEyLjQgMTcuMTkgMTIuNDlMMTIuMDcgMjIuNUw2LjgzIDEyLjQ5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Icecream = createIcon('Icecream', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.79 11.9L12.05 18.12L15.22 11.91C15.11 11.83 15.01 11.75 14.92 11.66C14.08 12.19 13.07 12.5 12 12.5C10.93 12.5 9.92 12.19 9.08 11.66C8.99 11.75 8.89 11.83 8.79 11.9ZM6.83 12.49C5.25 12.4 4 11.1 4 9.5C4 8.01 5.09 6.77 6.52 6.54C6.75 3.72 9.12 1.5 12 1.5C14.88 1.5 17.25 3.72 17.48 6.54C18.91 6.77 20 8.01 20 9.5C20 11.09 18.76 12.4 17.19 12.49L12.07 22.5L6.83 12.49Z',
      key: '1f9n3u',
    },
  ],
]);

export default Icecream;
